/**
 * Gets a valid image URL with fallback logic
 * @param primaryImage - The primary image URL to try first
 * @param fallbackImage - The fallback image URL to use if primary is invalid
 * @returns A valid image URL or empty string if neither is valid
 */
export const getValidImageUrl = (
  primaryImage?: string | null,
  fallbackImage?: string | null,
): string => {
  // Check if primary image is valid (not empty, null, or whitespace)
  if (primaryImage && primaryImage.trim() !== '') {
    return primaryImage;
  }

  // Check if fallback image is valid (not empty, null, or whitespace)
  if (fallbackImage && fallbackImage.trim() !== '') {
    return fallbackImage;
  }

  // Return empty string if neither image is valid
  return '';
};
